// extracted by mini-css-extract-plugin
export default {"wrapper":"menu-item-module--wrapper--TfKvI","title":"menu-item-module--title--z8tjg","links":"menu-item-module--links--ZQWMS","link":"menu-item-module--link--SaOpe"};